import { ActionAny, ActionRequest, createActions } from 'src/utils/createActions';
import { KeyPhrase } from 'src/types/entities/KeyPhrase';

export type KeyPhraseSynonymsCheckRequest =
    ActionRequest<ReadonlyArray<string>>;
export type KeyPhraseSynonymsCheckActions =
    ActionAny<ReadonlyArray<string>, KeyPhrase[]>;
export const KEY_PHRASE_SYNONYMS_CHECK_ACTIONS =
    createActions<ReadonlyArray<string>, KeyPhrase[]>('KEY_PHRASE_SYNONYMS_CHECK');
